exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notifications-page-container{flex:1;min-height:0;overflow-y:auto;padding:16px}body.has-bottom-nav .notifications-page-container{padding-bottom:calc(16px + var(--bottom-nav-height, 4.5em))}", ""]);

// exports
